<template>
	<div
		ref="popupContainer"
		class="relative inline-block"
		@mouseenter="showPopup()"
		@mouseleave="hidePopup()"
	>
		<slot name="content" />
		<transition name="fade">
			<Popup
				ref="popup"
				class="absolute"
				:style="{ ...popupPosition }"
				v-show="popupShown && !disabled"
			>
				<slot name="popup" />
			</Popup>
		</transition>
	</div>
</template>

<script>
    import Popup from "./Popup";

	export default {
        name: "PopupPlaceholder",
		data() {
        	return {
				popupShown: false,
				popupPosition: null
			}
		},
		props: {
        	disabled: {
				type: Boolean,
				default: false,
			}
		},
		methods: {

			showPopup() {
				const popup = this.$refs.popup.$el;
				const container = this.$refs.popupContainer;

				const { x, y, width, height } = container.getBoundingClientRect();
				const screenWidth = document.documentElement.clientWidth;
				const screenHeight = document.documentElement.clientHeight;

				const remainingWidthToLeftEdge = x + Math.ceil(container.clientWidth / 2);
				const remainingWidthToRightEdge = screenWidth - x - (width / 2);
				const remainingHeightToBottomEdge = screenHeight - (y + height);

				let top, right, bottom, left, margin;

				if (remainingHeightToBottomEdge > 150) {
					top = '130%';
				} else {
					bottom = '130%';
				}

				if (remainingWidthToLeftEdge < 112 && remainingWidthToRightEdge < 112) {
					left = '50%';
				} else if (remainingWidthToLeftEdge < 112) {
					left = `-${x}px`;
					margin = 0;
				} else if (remainingWidthToRightEdge < 112) {
					right = '0';
					margin = 0;
				} else {
					left = '50%';
				}

				this.popupPosition = {
					top,
					left,
					right,
					bottom,
					margin
				}

				this.popupShown = true;
			},

			hidePopup() {
				this.popupShown = false;
			},
		},
		components: {Popup}
	}
</script>

<style scoped>

</style>
